<script>
  import {getContext, onMount} from 'svelte';
  import {get} from 'svelte/store';
  import QRCode from 'qrcode';
  import {sd} from '@/da';
  import {Button} from '@px/button';
  import {goto} from '@sapper/app';
  import {PATHS} from '@/const/paths';
  import {LINKS} from '@/const/link';
  import {isLogin$} from '@/streams/auth';
  import {envUtil} from '@/helper/env';
  import {innerWidth$} from '@/streams/window-inner-size';
  import {fixLink$, lang$} from '@/store/lang';
  import {loginUtil} from '@/helper/login';
  import {bannerConfig$} from '@/modules/homepage/streams';
  import {welcomeBonusAmount$} from '@/modules/bonus/rewards-hub/stream';
  import {openDepositDrawer} from '@/modules/components/deposit/utils';
  import LoginBlock from '@/modules/homepage/components/LoginBlock.svelte';
  import AnnounceMarquee from '@/modules/homepage/components/AnnounceMarquee.svelte';
  import BannerCrypto from '@/modules/homepage/components/BannerCrypto.svelte';
  import BannerTextArrow from '@/modules/homepage/components/BannerTextArrow.svelte';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
  const language = get(lang$);

  let account = '';
  let qrcodeUrl = '';

  $: loading = $bannerConfig$.loading;
  $: bannerInfo = $bannerConfig$.info;
  $: bannerValid = JSON.stringify($bannerConfig$.info) !== '{}';

  onMount(async () => {
    const href = window.location.origin + PATHS.DOWNLOAD.pathname;
    qrcodeUrl = await QRCode.toDataURL(href);
  });

  function handleClickTrade(e) {
    e.stopPropagation();
    sd.track('web_click', {$screen_name: 'home', $element_content: 'Trade'});
    goto($fixLink$(LINKS.PHEMEX_CONTRACT_TRADE) + '/BTC-USDT');
  }

  function handleClickDeposit(e) {
    e.stopPropagation();
    sd.track('web_click', {$screen_name: 'home', $element_content: 'deposit'});
    openDepositDrawer({LG});
  }

  function handleClickLogin() {
    loginUtil.loginOrRegisterForCompatible($innerWidth$, $fixLink$, LG);
  }

  function handleToRegister() {
    goto($fixLink$(PATHS.REGISTER.pathname));
  }

  function handleBannerClick(sdKey, e) {
    if (bannerValid && bannerInfo.webLink) {
      if (sdKey === 'Banner_Text') {
        e.stopPropagation();
      }
      sd.track('web_click', {$screen_name: 'home', $element_content: sdKey || 'Banner'});
      window.open(bannerInfo.webLink, '_self', 'noopener');
    }
  }
</script>

<style>
  .wrap {
    position: relative;
    margin-top: -66px;
    box-sizing: border-box;
    padding-top: 64px;
    min-height: 600px;
    background: #090a0a;
    overflow: hidden;
  }
  .left {
    /*UI要求，为了适应右边文案行*/
    padding-bottom: 12px;
    height: 100%;
    cursor: default;
  }
  .banner {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 600px;
    cursor: pointer;
  }
  .banner > img {
    position: absolute;
    top: 0;
    right: 0;
    height: calc(100% - 76px);
    max-height: 546px;
    transform: translateX(-40px);
  }
  .main {
    z-index: 0;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 64px 0;
    width: 1200px;
    height: 100%;
  }
  .title {
    margin: 0;
    line-height: 64px;
    font-weight: 700;
    font-size: 48px;
  }
  .sub-title {
    margin-top: 12px;
    line-height: 22px;
    font-weight: 400;
    font-size: 16px;
  }
  :global(.btn-banner) {
    border-radius: 32px !important;
    min-width: 192px;
    height: 52px !important;
    line-height: 52px !important;
    font-weight: 500 !important;
    font-size: 16px !important;
  }
  :global(.btn-banner.btn-join-deposit) {
    border-color: #fff !important;
    background: transparent !important;
  }
  :global(.btn-banner.btn-join-deposit:hover) {
    opacity: 0.8;
  }
  .download > h4 {
    margin: 0;
  }
  .qrcode {
    display: inline-block;
    box-sizing: border-box;
    border-radius: 12px;
    padding: 8px;
    width: 90px;
    height: 90px;
    background: #fff;
  }
  .gap-24 {
    gap: 24px;
  }
  .udn {
    user-drag: none;
    -webkit-user-drag: none;
  }
  .banner-TD {
    position: absolute;
    right: 0;
    bottom: 76px;
  }
  .fw4 {
    font-weight: 700;
  }
  .shining {
    background: linear-gradient(271deg, var(--banner-title-theme-color1) 17.27%, var(--banner-title-theme-color2) 81.03%, var(--banner-title-theme-color1) 100%);
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    gap: 8px;
    animation: shine 2s infinite;
  }
  .btn-group {
    margin-top: 106px;
  }
  @keyframes shine {
    100% {
      background-position: -200%;
    }
  }
  @media screen and (max-width: 640px) {
    .wrap {
      margin-top: 0;
      padding-top: 0;
      height: auto;
      background-image: none;
      min-height: auto;
    }
    .banner {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      text-align: center;
    }
    .banner > img {
      position: unset;
      width: 100%;
      height: auto;
      object-fit: cover;
      transform: unset;
    }
    .main {
      flex-direction: column;
      padding: 20px 16px;
      width: 100%;
    }
    .left {
      width: 100%;
      height: auto;
      text-align: center;
      padding-bottom: 0;
    }
    .title {
      line-height: 38px;
      font-size: 32px;
    }
    :global(.btn-login) {
      min-width: 200px !important;
    }
    .sub-title {
      margin-top: 20px;
      line-height: 14px;
      font-size: 12px;
    }
    .btn-group {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      margin-top: 0;
    }
    .btn-group :global(.btn-banner) {
      flex: 1;
    }
    :global(.btn-banner) {
      border-radius: 32px !important;
      min-width: 140px;
      height: 40px !important;
      line-height: 40px !important;
      font-weight: 500 !important;
      font-size: 14px !important;
    }
    .pt32 {
      padding-top: 32px;
    }
  }
</style>

<section class="wrap">
  {#if !loading}
    <div class="main pr df aic jcsb TW" class:pt32={envUtil.isMobile && !bannerValid}>
      {#if bannerValid && !loading}
        <div class="banner" on:click={handleBannerClick.bind(null, 'Banner')}>
          {#if envUtil.isApp || envUtil.isMobile}
            <img src={bannerInfo.imageUrl} alt="H5 banner image" />
          {:else}
            <img src={bannerInfo.webimg} alt="WEB banner image" />
          {/if}
          {#if !envUtil.isMobile && !envUtil.isApp}
            <div class="df aic banner-TD" on:click={handleBannerClick.bind(null, 'Banner_Text')}>
              <div class="df fdc aife f1 mr8 tr">
                <span class="fw4 f16 shining" style="--banner-title-theme-color1: {bannerInfo.titleTextColors[0]}; --banner-title-theme-color2: {bannerInfo.titleTextColors[1]}"
                  >{bannerInfo.title}</span
                >
                <span class="fw1 f14 TW mt4">{bannerInfo.description}</span>
              </div>
              <BannerTextArrow color1={bannerInfo.titleTextColors[0]} color2={bannerInfo.titleTextColors[1]} />
            </div>
          {/if}
        </div>
      {/if}
      <div class="f1 df fdc jcfe left" class:left-has-activity={bannerValid} on:click|stopPropagation>
        <div>
          <h1 class="title">{@html LG(lang.EfficientCryptoExchange)}</h1>
        </div>
        <div>
          {#if $isLogin$}
            <div class="df gap-24 btn-group">
              <Button class="btn-banner btn-join mt20" on:click={handleClickTrade}>{LG(lang.Trade)}</Button>
              <Button class="btn-banner btn-join-deposit mt20" on:click={handleClickDeposit}>{LG(lang.Deposit)}</Button>
            </div>
          {:else if envUtil.isMobile || envUtil.isApp}
            <div class="sub-title">{@html LG(lang.BonusText, {WelcomeReards: `<span style="color: #40F700">$${$welcomeBonusAmount$}</span>`})}</div>
            <Button class="btn-banner btn-login mt8" on:click={handleToRegister}>{LG(lang.SignUp)}</Button>
          {:else}
            <div class="sub-title">{@html LG(lang.BonusText, {WelcomeReards: `<span style="color: #40F700">$${$welcomeBonusAmount$}</span>`})}</div>
            <LoginBlock />
          {/if}
          <AnnounceMarquee />
        </div>
      </div>
      {#if !loading}
        <BannerCrypto legality={bannerValid} />
      {/if}
    </div>
  {/if}
</section>
